export const getRelativeTime = (dateString: string, locale: string): string => {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  const seconds = Math.max(0, Math.floor(diffMs / 1000));
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const rtf = new Intl.RelativeTimeFormat(locale, {
    numeric: 'auto',
  });

  if (days !== 0) return rtf.format(-days, 'day');
  if (hours !== 0) return rtf.format(-hours, 'hour');
  if (minutes !== 0) return rtf.format(-minutes, 'minute');
  return rtf.format(-seconds, 'second');
};
